import { useEffect, useState } from "react";
import { Col, Form, Image, Input, Modal, Radio, Row, Select, Typography, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { getCookie } from "../../utils/localStorageHandle";
import * as CONSTANTS from "../../utils/constants";
import { FormatVND } from "../../utils/format";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { PickWareHouse } from "../../helper";
import axiosInstance from "../../utils/axios";
import CustomUpload from "../../component/customUpload";
import { useDevice } from "../../hooks";

export default function Checkout() {
    const { isMobile } = useDevice();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [cart, setCart] = useState([]);
    const [province, setProvince] = useState([]);
    const [district, setDistrict] = useState([]);
    const [ward, setWard] = useState([]);
    const [loading, setLoading] = useState(false);

    const [fromAddress, setFromAddress] = useState("");
    const [selectProvince, setSelectProvince] = useState({});
    const [selectDistrict, setSelectDistrict] = useState({});
    const [selectWard, setSelectWard] = useState({});
    const [shipFee, setShipFee] =  useState(0);
    const [totalBill, setTotalBill] =  useState(0);
    const [payment, setPayment] = useState(3);
    const [imgTransfer, setImgTransfer] = useState("");
    const [paymentSettings, setPaymentSettings] = useState({
        bank_qr: "",
        bank_name: "",
        bank_account_name: "",
        bank_account_number: "",
        momo_qr: "",
        momo_account_name: "",
        momo_account_number: ""
    });

    const [voucher, setVoucher] = useState({});
    const user = JSON.parse(localStorage.getItem("user"));

    const isOnlineItem = (item) => {
        const charValues = (
            item?.characteristics?.values ||
            item?.characteristics?.values_attribute ||
            ""
        ).toLowerCase();

        let images = [];

        try {
            images =
                typeof item?.product_image === "string"
                    ? JSON.parse(item.product_image)
                    : (item?.product_image || []);
        } catch (error) {
            images = [];
        }

        return (
            charValues.includes("online") ||
            (
                Array.isArray(images) &&
                images.some(img => img?.type === "file")
            )
        );
    };

    const isAllOnlineCart =
        Array.isArray(cart) &&
        cart.length > 0 &&
        cart.every(isOnlineItem);

    /*
     * UI moi CHI danh cho:
     * - dien thoai
     * - 100% sach Online
     * - tong gio hang > 3.000d
     *
     * Don tang / don nho khong dong toi.
     */
    const useOnlineMobileCheckout =
        isMobile &&
        isAllOnlineCart &&
        Number(totalBill || 0) > 3000;

    const checkoutTotal =
        voucher?.voucher_id
            ? Number(totalBill || 0) -
              Number(voucher?.voucher_price || 0) +
              Number(shipFee || 0)
            : Number(totalBill || 0) +
              Number(shipFee || 0);

    const getCover = (item) => {
        try {
            const images =
                typeof item?.product_image === "string"
                    ? JSON.parse(item.product_image)
                    : item?.product_image;

            return (
                images?.find(img => img?.type === "image")?.data ||
                ""
            );
        } catch (error) {
            return "";
        }
    };

    const fetchPaymentSettings = async () => {
        try {
            const res = await axiosInstance.get("/payment-settings/web");
            const data = res?.data?.data || {};

            setPaymentSettings({
                bank_qr: data.bank_qr || "",
                bank_name: data.bank_name || "",
                bank_account_name: data.bank_account_name || "",
                bank_account_number: data.bank_account_number || "",
                momo_qr: data.momo_qr || "",
                momo_account_name: data.momo_account_name || "",
                momo_account_number: data.momo_account_number || ""
            });
        } catch (error) {
            console.error("Không thể tải tài khoản thanh toán:", error);
        }
    };

    const fetchProvinceByGHN = async () => {
        await axios.get(`${process.env.REACT_APP_API_GHN_URL}/master-data/province`, {
            headers: {
                'Content-Type': 'application/json',
                'Token': process.env.REACT_APP_GHN_TOKEN,
            }
        })
          .then((res) => {
            const data = res?.data;
            setProvince(data);
          })
          .catch(() => message.error("Error server!"));
    };

    const handleProvinceChange = async (value) => {
        form.setFieldsValue({ district: null });
        const selected = province?.data?.find(item => item?.ProvinceID === value);
        const ProvinceName = selected?.ProvinceName;
        setSelectProvince({ProvinceID: value, ProvinceName: ProvinceName});
        
        await axios.get(`${process.env.REACT_APP_API_GHN_URL}/master-data/district`, {
            headers: {
                'Content-Type': 'application/json',
                'Token': process.env.REACT_APP_GHN_TOKEN,
            },
            params: {
                province_id: value,
            }
        })
          .then((res) => {
            const data = res?.data;
            setDistrict(data);
          })
          .catch(() => message.error("Error server!"));
    }

    const handleDistrictChange = async (value) => {
        form.setFieldsValue({ ward: null });
        const selected = district?.data?.find(item => item?.DistrictID === value);
        setSelectDistrict({DistrictID: value, DistrictName: selected?.DistrictName});
        await axios.get(`${process.env.REACT_APP_API_GHN_URL}/master-data/ward`, {
            headers: {
                'Content-Type': 'application/json',
                'Token': process.env.REACT_APP_GHN_TOKEN,
            },
            params: {
                district_id: value,
            }
        })
          .then((res) => {
            const data = res?.data;
            setWard(data);
          })
          .catch(() => message.error("Error server!"));
    }

    const handleWardChange =async (value) => {
        const selected = ward?.data?.find(item => item?.WardCode === value);
        setSelectWard({WardCode: value, WardName: selected?.WardName});
        
        const pick = PickWareHouse(selectProvince?.ProvinceName);
        setFromAddress(pick?.pick_province);
        
        await axios.get(`${process.env.REACT_APP_API_GHN_URL}/v2/shipping-order/available-services?shop_id=5321596&from_district=${pick?.from_district_id}&to_district=${selectDistrict?.DistrictID}`, {    
                headers: {
                    'Content-Type': 'application/json',
                    'Token': process.env.REACT_APP_GHN_TOKEN,
                },
            }).then(async (res) => {
                const data = res?.data;
                await axios.post(`${process.env.REACT_APP_API_GHN_URL}/v2/shipping-order/fee`, 
                {
                    "service_id": data?.data[0]?.service_id,
                    "insurance_value":1000000,
                    "coupon": null,
                    "from_district_id": pick?.from_district_id,
                    "to_district_id": selectDistrict?.DistrictID,
                    "to_ward_code": value,
                    "height":15,
                    "length":15,
                    "weight":1000,
                    "width":15
                },{    
                    headers: {
                        'Content-Type': 'application/json',
                        'Token': process.env.REACT_APP_GHN_TOKEN,
                    },
                })
                .then((res) => {
                    const data = res?.data?.data;
                    const hasNonFileProduct = cart.some(item => {
                        const productImages = JSON.parse(item?.product_image);
                        const isFileByImage = productImages?.some(img => img.type === 'file');
                        const characteristicValues = (item.characteristics?.values || item.characteristics?.values_attribute || "")?.toLowerCase();
                        const isOnlineByDesc = characteristicValues.includes("online");
                        return !isFileByImage && !isOnlineByDesc;
                    });
                    
                    if (hasNonFileProduct) {
                        setShipFee(data?.service_fee);
                    } else {
                        setShipFee(0);
                    }
                })
                .catch(() => setShipFee(40000));
            })
            .catch(() => message.error("Error server!"));

    }

    const handleClickVoucher = async () => {
        if(voucher?.voucher_code) {
            await axios.get(`${process.env.REACT_APP_API_URL}/voucher/getByVoucherCode/${voucher?.voucher_code}`)
                .then((res) => {
                const data = res?.data;
                if(data?.status === 1) {
                    if (totalBill > data?.data?.voucher_level) {
                        message.success(String(data?.message));
                        setVoucher(data?.data);
                    } else {
                        message.info("Mã voucher chưa đủ điều kiện để áp dụng!");
                    }
                } else {
                    message.info(String(data?.message));
                }
                })
                .catch(() => message.error("Error server!"));
        } else {
            message.info("Vui lòng nhập voucher!");
        }
    }

    const handleClickCheckOut = async (value) => {
        if (loading) return; // Prevent multiple clicks
        
        let dataProduct = [];
        (cart || []).filter(item => item !== null && item !== undefined).map((item) => {
            let newProduct = {
                product_id: item.product_id,
                product_name: item.product_name,
                quantity: item.quantity,
                description: (item.characteristics?.values || item.characteristics?.values_attribute || ""),
                hash: item.characteristics?.characteristics_hash,
                price: item.totalprice,
            };
            dataProduct.push(newProduct);
        });

        const isAllOnline = cart?.every(item => {
            const charValues = (item.characteristics?.values || item.characteristics?.values_attribute || "")?.toLowerCase();
            return charValues.includes("online") || JSON.parse(item?.product_image)?.some(img => img.type === 'file');
        });

        if(imgTransfer || payment == 1 || (isAllOnline && totalBill == 0)) {
            setLoading(true);
            const transfer_content = `${user?.displayName} chuyen tien`;
            
            const dateMerge = {
                dataProduct: dataProduct,
                fullname: value?.fullname,
                email: value?.email,
                phone: value?.phone,
                from_address: fromAddress || null,
                to_address: value?.address + ", " + selectWard?.WardName + ", " + selectDistrict?.DistrictName + ", " + selectProvince?.ProvinceName || null,
                voucher_id: voucher?.voucher_id ? voucher?.voucher_id : null,
                fee_ship: shipFee || 0,
                message: value?.note || null,
                total_price: voucher?.voucher_id ? totalBill - voucher?.voucher_price + shipFee : totalBill + shipFee,
                payment: payment || null,
                transfer_content: transfer_content || null,
                transfer_image: imgTransfer || null,
                user_id: user?.user_id
            }

            await axiosInstance.post(`/order/create`, dateMerge)
                .then((res) => {
                    const data = res?.data;
                    message.success(String(data?.message));
                    form.resetFields();                
                    localStorage.removeItem(CONSTANTS.cartCookie);
                    navigate("/");
                }) 
                .catch((err) => {
                    console.error(err);
                    message.error(err?.response?.data?.message || "Lỗi server khi đặt hàng!");
                })
                .finally(() => setLoading(false));
        }
        else {
            message.info(String("Bạn đang điền thiếu ảnh chứng minh!"))
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProvinceByGHN();
        fetchPaymentSettings();
        setCart(JSON.parse(getCookie(CONSTANTS.cartCookie)));
    }, []);

    useEffect(() => {
        setTotalBill(cart?.reduce((acc, { totalprice }) => acc + parseInt(totalprice), 0));
    }, [cart]);

    /*
     * ======================================================
     * CHECKOUT RIENG CHO MOBILE + SACH ONLINE CO PHI
     * ======================================================
     *
     * Return rieng tai day.
     * Vi vay giao dien checkout cu KHONG THE hien chong len.
     */
    if (useOnlineMobileCheckout) {
        return (
            <div className="bg-white min-h-screen pb-[95px] pt-[45px]">

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleClickCheckOut}
                    initialValues={{
                        email: user?.email || "",
                        fullname: user?.displayName || "",
                        phone: user?.phone || ""
                    }}
                >

                    {/* TAT CA SAN PHAM */}
                    <div className="divide-y divide-gray-100">

                        {cart?.map((item, index) => {

                            const cover = getCover(item);

                            return (
                                <div
                                    key={`${item?.product_id || index}-${index}`}
                                    className="flex gap-4 px-5 py-4"
                                >

                                    <div className="w-[92px] h-[92px] rounded-2xl bg-gray-50 overflow-hidden flex-shrink-0">

                                        {cover && (
                                            <img
                                                src={cover}
                                                alt={item?.product_name || "Sách"}
                                                className="w-full h-full object-cover"
                                            />
                                        )}

                                    </div>

                                    <div className="flex-1 min-w-0">

                                        <p className="text-[17px] leading-[1.35] font-bold text-gray-900 mb-2 line-clamp-2">
                                            {item?.product_name}
                                        </p>

                                        <div className="flex items-end justify-between gap-2">

                                            <div>
                                                <p className="text-[19px] font-bold text-[#a34d66] mb-1">
                                                    {FormatVND(item?.totalprice)}
                                                </p>

                                                <p className="text-[12px] text-gray-400 mb-0">
                                                    Sách bản online
                                                </p>
                                            </div>

                                            <span className="text-[13px] text-gray-500">
                                                SL: {item?.quantity || 1}
                                            </span>

                                        </div>

                                    </div>

                                </div>
                            );
                        })}

                    </div>


                    {/* TOM TAT DON */}
                    <div className="mx-5 mb-4 rounded-2xl bg-[#f8f8fb] px-4 py-4">

                        <div className="flex justify-between text-[14px] mb-2">
                            <span className="text-gray-500">
                                {cart?.length || 0} sản phẩm
                            </span>

                            <span className="font-semibold">
                                {FormatVND(totalBill)}
                            </span>
                        </div>

                        <div className="flex justify-between text-[14px]">
                            <span className="text-gray-500">
                                Phí vận chuyển
                            </span>

                            <span className="font-semibold text-green-600">
                                Miễn phí
                            </span>
                        </div>

                    </div>


                    {/* THONG TIN MUA HANG */}
                    <div className="px-5 pt-4 pb-6">

                        <h2 className="text-[22px] font-bold text-gray-900 mb-5">
                            Thông tin mua hàng
                        </h2>

                        <div className="space-y-3">

                            <Form.Item
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng nhập email!"
                                    }
                                ]}
                                className="!mb-0"
                            >
                                <Input
                                    type="email"
                                    placeholder="Email"
                                    className="!h-[52px] !rounded-2xl !border-0 !bg-[#f7f7fb] !px-5 !text-[17px]"
                                />
                            </Form.Item>


                            <Form.Item
                                name="fullname"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng nhập họ và tên!"
                                    }
                                ]}
                                className="!mb-0"
                            >
                                <Input
                                    placeholder="Họ và tên"
                                    className="!h-[52px] !rounded-2xl !border-0 !bg-[#f7f7fb] !px-5 !text-[17px]"
                                />
                            </Form.Item>


                            <Form.Item
                                name="phone"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vui lòng nhập số điện thoại!"
                                    }
                                ]}
                                className="!mb-0"
                            >
                                <Input
                                    type="tel"
                                    inputMode="tel"
                                    placeholder="Số điện thoại"
                                    className="!h-[52px] !rounded-2xl !border-0 !bg-[#f7f7fb] !px-5 !text-[17px]"
                                />
                            </Form.Item>


                            <Form.Item
                                name="note"
                                className="!mb-0"
                            >
                                <Input
                                    placeholder="Ghi chú"
                                    className="!h-[52px] !rounded-2xl !border-0 !bg-[#f7f7fb] !px-5 !text-[17px]"
                                />
                            </Form.Item>

                        </div>

                    </div>


                    {/* PHUONG THUC */}
                    <div className="px-5 pt-4 pb-5 border-t border-gray-100">

                        <h2 className="text-[22px] font-bold text-gray-900 mb-3">
                            Hình thức thanh toán
                        </h2>


                        {/* COD */}
                        <button
                            type="button"
                            onClick={() => setPayment(1)}
                            className="w-full flex items-center gap-4 py-4 text-left"
                        >

                            <span
                                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                                    payment === 1
                                        ? "border-[#a34d66]"
                                        : "border-gray-500"
                                }`}
                            >
                                {payment === 1 && (
                                    <span className="w-3 h-3 rounded-full bg-[#a34d66]" />
                                )}
                            </span>

                            <span className="flex-1">

                                <span className="block text-[18px] text-gray-900">
                                    Thanh toán khi nhận hàng
                                </span>

                                <span className="block text-[13px] leading-5 text-orange-600 mt-1">
                                    Ưu tiên chuyển khoản để nhận bản đọc Online nhanh nhất.
                                </span>

                            </span>

                        </button>


                        {/* BANK */}
                        <button
                            type="button"
                            onClick={() => setPayment(2)}
                            className="w-full flex items-center gap-4 py-4 text-left"
                        >

                            <span
                                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                                    payment === 2
                                        ? "border-[#a34d66]"
                                        : "border-gray-500"
                                }`}
                            >
                                {payment === 2 && (
                                    <span className="w-3 h-3 rounded-full bg-[#a34d66]" />
                                )}
                            </span>

                            <span className="flex-1">

                                <span className="block text-[18px] text-gray-900">
                                    Chuyển khoản ngân hàng
                                </span>

                                <span className="block text-[13px] text-green-600 font-medium mt-1">
                                    Nhận sách ngay lập tức
                                </span>

                            </span>

                        </button>


                        {/* MOMO */}
                        <button
                            type="button"
                            onClick={() => setPayment(3)}
                            className="w-full flex items-center gap-4 py-4 text-left"
                        >

                            <span
                                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                                    payment === 3
                                        ? "border-[#a34d66]"
                                        : "border-gray-500"
                                }`}
                            >
                                {payment === 3 && (
                                    <span className="w-3 h-3 rounded-full bg-[#a34d66]" />
                                )}
                            </span>

                            <span className="flex-1">

                                <span className="block text-[18px] text-gray-900">
                                    MoMo
                                </span>

                                <span className="block text-[13px] text-green-600 font-medium mt-1">
                                    Nhận sách ngay lập tức
                                </span>

                            </span>

                        </button>

                    </div>


                    {/* CHUYEN KHOAN */}
                    {(payment === 2 || payment === 3) && (

                        <div className="px-5 pb-5">

                            <div className="rounded-3xl bg-[#faf9fd] px-5 py-6 text-center">

                                {(payment === 2
                                    ? paymentSettings.bank_qr
                                    : paymentSettings.momo_qr) && (

                                    <img
                                        src={
                                            payment === 2
                                                ? paymentSettings.bank_qr
                                                : paymentSettings.momo_qr
                                        }
                                        alt="QR thanh toán"
                                        className="w-full max-w-[215px] aspect-square object-contain mx-auto"
                                    />

                                )}


                                {payment === 2 && (
                                    <Typography.Paragraph
                                        className="!mt-5 !mb-2 !text-[19px] !font-bold !text-gray-900"
                                        copyable={{
                                            text: paymentSettings.bank_name,
                                            tooltips: [
                                                "Sao chép tên ngân hàng",
                                                "Đã sao chép"
                                            ]
                                        }}
                                    >
                                        {paymentSettings.bank_name}
                                    </Typography.Paragraph>
                                )}


                                <p className="mb-2 text-[18px] font-bold text-gray-900">
                                    {payment === 2
                                        ? paymentSettings.bank_account_name
                                        : paymentSettings.momo_account_name}
                                </p>


                                <Typography.Paragraph
                                    className="!mb-0 !text-[18px] !font-bold"
                                    copyable={{
                                        text:
                                            payment === 2
                                                ? paymentSettings.bank_account_number
                                                : paymentSettings.momo_account_number,
                                        tooltips: [
                                            "Sao chép",
                                            "Đã sao chép"
                                        ]
                                    }}
                                >
                                    {payment === 2
                                        ? `Số tài khoản: ${paymentSettings.bank_account_number}`
                                        : `Số MoMo: ${paymentSettings.momo_account_number}`}
                                </Typography.Paragraph>

                            </div>


                            <p className="text-[15px] leading-6 text-gray-600 mt-4 mb-3">
                                Chuyển đúng{" "}
                                <b>{FormatVND(checkoutTotal)}</b>{" "}
                                rồi tải ảnh xác nhận bên dưới.
                            </p>


                            <div className="rounded-2xl border border-gray-300 p-4 mb-5">

                                <p className="text-[15px] font-semibold text-[#a34d66] text-center mb-3">
                                    Tải ảnh chuyển khoản
                                </p>

                                <div className="flex justify-center">

                                    <CustomUpload
                                        type="image"
                                        accept=".png, .jpg, .jpeg, .jfif"
                                        onChange={(transfer_image) =>
                                            setImgTransfer(transfer_image)
                                        }
                                        value={imgTransfer}
                                    />

                                </div>

                                {imgTransfer && (
                                    <p className="text-[12px] font-semibold text-green-600 text-center mt-2 mb-0">
                                        ✓ Đã thêm ảnh xác nhận
                                    </p>
                                )}

                            </div>

                        </div>

                    )}


                    {/* TOTAL */}
                    {payment > 0 && (

                        <div className="px-5 pb-5">

                            <div className="rounded-3xl bg-[#f8f7fb] px-5 py-5 flex items-center justify-between">

                                <span className="text-[18px] font-bold">
                                    Tổng thanh toán
                                </span>

                                <span className="text-[22px] font-bold">
                                    {FormatVND(checkoutTotal)}
                                </span>

                            </div>

                        </div>

                    )}


                    {/* BUTTON */}
                    {payment > 0 && (

                        <div className="px-5 pb-8">

                            <Form.Item className="!mb-0">

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className={`w-full min-h-[54px] rounded-full text-[18px] font-bold ${
                                        loading
                                            ? "bg-gray-300 text-gray-500"
                                            : "bg-[#a34d66] text-white"
                                    }`}
                                >
                                    {loading
                                        ? "Đang đặt hàng..."
                                        : "Xác nhận đặt hàng"}
                                </button>

                            </Form.Item>

                        </div>

                    )}

                </Form>

            </div>
        );
    }


    return (
        <div className="max-w-screen-2xl mx-auto my-5">
            <div className="flex">
                <a href="">Trang chủ</a> 
                <p className="px-2">/</p> 
                <a href="/gio-hang">Giỏ hàng</a>
                <p className="px-2">/</p> 
                <a href="/thanh-toan">Trang thanh toán</a>
            </div>

            <Form 
                form={form}
                layout={"vertical"}
                onFinish={handleClickCheckOut}
            >
                <Row>
                    <Col xs={24} xl={24} className='my-5 p-10 bg-white'>
                        <p className="text-xl font-semibold pb-10 text-center">Thông tin mua hàng</p>
                        <Row>
                            <Col xs={24} xl={8} className="px-1">
                                <Form.Item
                                    label={"Email"}
                                    name="email"
                                    rules={[{ required: true, message: "Vui lòng nhập email!" }]}
                                >
                                    <Input type="email" size="large" placeholder={"nguyen@gmail.com"} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={8} className="px-1">
                                <Form.Item
                                    label={"Họ và tên"}
                                    name="fullname"
                                    rules={[{ required: true, message: "Vui lòng nhập họ và tên!" }]}
                                >
                                    <Input type="text" size="large" placeholder={"Nguyễn Văn A"} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} xl={8} className="px-1">
                                <Form.Item
                                    label={"Số điện thoại"}
                                    name="phone"
                                    rules={[{ required: true, message: "Vui lòng nhập số điện thoại!" }]}
                                >
                                    <Input type="number" size="large" placeholder={"0945125123"} />
                                </Form.Item>
                            </Col>
                            {!cart?.every(item => {
                                const charValues = (item.characteristics?.values || item.characteristics?.values_attribute || "")?.toLowerCase();
                                return charValues.includes("online") || JSON.parse(item?.product_image)?.some(img => img.type === 'file');
                            }) && (
                                <>
                                    <Col xs={24} xl={8} className="px-1">
                                        <Form.Item
                                            label={"Tỉnh"}
                                            name="province"
                                            rules={[{ required: true, message: "Vui lòng chọn Tỉnh!" }]}
                                        >
                                            <Select
                                                size="large"
                                                placeholder="Chọn Tỉnh"
                                                optionFilterProp="children"
                                                onChange={handleProvinceChange}
                                                options={province?.data?.map((value) => ({
                                                    value: value.ProvinceID,
                                                    label: value.ProvinceName,
                                                }))}
                                            />
                                        </Form.Item>
                                    </Col>
        
                                    <Col xs={24} xl={8} className="px-1">
                                        <Form.Item
                                            label={"Quận/ Huyện"}
                                            name="district"
                                            rules={[{ required: true, message: "Vui lòng chọn Quận/ Huyện!" }]}
                                        >
                                            <Select
                                                size="large"
                                                placeholder="Chọn Quận/ Huyện"
                                                optionFilterProp="children"
                                                onChange={handleDistrictChange}
                                                disabled={district?.length === 0}
                                                options={district?.data?.map((value) => ({
                                                    value: value.DistrictID,
                                                    label: value.DistrictName,
                                                }))}
                                            />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col xs={24} xl={8} className="px-1">
                                        <Form.Item
                                            label={"Phường/ Xã"}
                                            name="ward"
                                            rules={[{ required: true, message: "Vui lòng chọn Phường/ Xã!" }]}
                                        >
                                            <Select
                                                size="large"
                                                placeholder="Chọn Phường/ Xã"
                                                optionFilterProp="children"
                                                onChange={handleWardChange}
                                                disabled={ward?.length === 0}
                                                options={ward?.data?.map((value) => ({
                                                    value: value.WardCode,
                                                    label: value.WardName,
                                                }))}
                                            />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col xs={24} xl={24}>
                                        <Form.Item
                                            label={"Địa chỉ chi tiết"}
                                            name="address"
                                            className="col-span-3"
                                            rules={[{ required: true, message: "Vui lòng nhập địa chỉ chi tiết!" }]}
                                        >
                                            <Input type="text" size="large" placeholder={"Đường A, Khu phố B..."} />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col xs={24} xl={24}>
                                        <Form.Item
                                            label={"Ghi chú"}
                                            className="col-span-3"
                                            name="note"
                                            rules={[{ required: false, message: "Vui lòng nhập địa chỉ!" }]}
                                        >
                                            <TextArea rows={4} placeholder="Viết ghi chú ..." />
                                        </Form.Item>
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Col>
                </Row>
                
                <Row>
                    <Col xs={24} xl={8} className="px-2">
                        {cart && (
                            <div>
                                <div className="border bg-white pb-5">
                                    <p className="text-xl font-bold py-10 mb-5 text-center border-b bg-blue-50">Đơn hàng</p>
                                    <div className="border-b pb-5">
                                        <div className="px-5 pb-5 flex items-center grid grid-cols-5 gap-2 font-semibold">
                                            <p className="col-span-2">Tên sản phẩm</p>
                                            <p className="text-center">Ảnh</p>
                                            <p className="text-center">Số lượng</p>
                                            <p className="text-center">Thành tiền</p>
                                        </div>
                                        {cart?.map((_,i) => (
                                            <div className="px-5 py-2 flex items-center grid grid-cols-5 gap-2 text-base">
                                                <p className="col-span-2">{_?.product_name?.slice(0, 40)}...</p>
                                                <div className="flex justify-center">
                                                    <Image src={JSON.parse(_?.product_image)?.filter((img) => img.type === 'image')?.[0]?.data} width={60}/>
                                                </div>
                                                <p className="text-center">{_?.quantity}</p>
                                                <p className="text-[#FF424E] font-semibold">{FormatVND(_?.totalprice)}</p>
                                            </div>
                                        ))}
                                        
                                        {!cart?.every(item => {
                                            const charValues = (item.characteristics?.values || item.characteristics?.values_attribute || "")?.toLowerCase();
                                            return charValues.includes("online") || JSON.parse(item?.product_image)?.some(img => img.type === 'file');
                                        }) && (
                                            <div className="grid grid-cols-3 px-5 flex items-center pt-10">
                                                <Input className="h-full col-span-2" type="text" value={voucher?.voucher_code} onChange={(e)=>setVoucher({voucher_code: e?.target?.value})} size="large" placeholder={"Mã giảm giá"} />

                                                <p className="w-full py-2 ml-2 bg-blue-500 text-white text-xl font-semibold hover:bg-blue-400 text-center cursor-pointer" onClick={handleClickVoucher}>
                                                    Áp dụng
                                                </p>
                                            </div>
                                        )}

                                    </div>
                                    <div className="p-5 border-b text-lg font-semibold">
                                        <div className="flex justify-between">
                                            <p>Tạm tính</p>
                                            <p className="text-[#FF424E]">{FormatVND(totalBill)}</p>
                                        </div>
                                        <div className="flex justify-between py-2">
                                            <p>Phí vận chuyển</p>
                                            <p className={`${shipFee ? "text-red-500" : "text-green-500"}`}>{shipFee? FormatVND(shipFee) : "Free"}</p>
                                        </div>
                                        {voucher?.voucher_price && (
                                            <div className="flex justify-between">
                                                <p>Mã giảm giá</p>
                                                <p className="text-green-500">{FormatVND(voucher?.voucher_price)}</p>
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-5">
                                        <div className="flex justify-between text-xl font-semibold">
                                            <p>Tổng tiền</p>
                                            <p className="text-[#FF424E]">
                                                {voucher?.voucher_price ? FormatVND(totalBill + shipFee - voucher?.voucher_price) : FormatVND(totalBill + shipFee)}
                                            </p>
                                        </div>
                                    </div>
                                    {JSON.parse(getCookie(CONSTANTS.cartCookie))?.reduce((total, item) => total + (item.totalprice || 0), 0) > 0 && (
                                        <div className="px-5 text-xl border-t pt-5">
                                            <p>Hình thức thanh toán:</p>
                                            <Radio.Group
                                                options={[
                                                    {
                                                        label: (
                                                                    <div className="py-1">
                                                                        <p className="text-lg mb-0">
                                                                            Thanh toán khi nhận hàng
                                                                        </p>
                                                                        <p className="text-sm text-orange-600 mt-1 mb-0">
                                                                            Ưu tiên chuyển khoản để nhận bản đọc Online nhanh nhất.
                                                                        </p>
                                                                    </div>
                                                                ),
                                                        value: 1,
                                                    },
                                                    {
                                                        label: (
                                                                    <div className="py-1">
                                                                        <p className="text-lg mb-0">
                                                                            Chuyển khoản ngân hàng
                                                                        </p>
                                                                        <p className="text-sm text-green-600 font-medium mt-1 mb-0">
                                                                            Nhận sách ngay lập tức
                                                                        </p>
                                                                    </div>
                                                                ),
                                                        value: 2,
                                                    },
                                                    {
                                                        label: (
                                                                    <div className="py-1">
                                                                        <p className="text-lg mb-0">
                                                                            MoMo
                                                                        </p>
                                                                        <p className="text-sm text-green-600 font-medium mt-1 mb-0">
                                                                            Nhận sách ngay lập tức
                                                                        </p>
                                                                    </div>
                                                                ),
                                                        value: 3,
                                                    },
                                                ]}
                                                onChange={(e)=>setPayment(e?.target?.value)}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="flex justify-center pt-2">
                                    {payment > 0 && payment == 1 ? (
                                        <Form.Item className="w-full">
                                            <button className="w-full py-2 bg-blue-500 text-white text-xl font-semibold hover:bg-blue-400" type="submit" disabled={loading}>
                                                {loading ? 'Đang đặt hàng...' : 'Đặt hàng'}
                                            </button>
                                        </Form.Item>
                                    ) : (
                                        <>
                                            {cart?.every(item => {
                                                const charValues = (item.characteristics?.values || item.characteristics?.values_attribute || "")?.toLowerCase();
                                                return charValues.includes("online") || JSON.parse(item?.product_image)?.some(img => img.type === 'file');
                                            }) && totalBill == 0 && (
                                                <Form.Item className="w-full">
                                                    <button className="w-full py-2 bg-blue-500 text-white text-xl font-semibold hover:bg-blue-400" type="submit" disabled={loading}>
                                                        {loading ? 'Đang đặt hàng...' : 'Đặt hàng'}
                                                    </button>
                                                </Form.Item>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </Col>                    
                    {(payment == 2 || payment == 3) && (
                        <Col xs={24} xl={16}>
                            <Row className="bg-white mb-5">
                                <Col xs={24} xl={14} className="p-5 border-r">
                                    <p className="font-semibold text-lg text-center pb-10">Thông tin chuyển khoản</p>
                                    <p className="flex px-5 pt-3 text-lg">
                                        Nội dung CK:
                                    <span className="font-semibold text-xl pl-5">{user?.displayName} chuyen tien</span>
                                    </p>
                                    <p className="px-5 pt-3 text-lg">
                                        Số tiền thanh toán:
                                    </p>
                                    <p className="font-semibold px-5 pb-3 text-xl text-sky-500">
                                        {FormatVND(voucher?.voucher_id ? totalBill - voucher?.voucher_price + shipFee : totalBill + shipFee)} VND
                                    </p>
                                    <p className="px-5 text-lg">
                                        Giá trị đơn hàng:
                                    </p>
                                    <p className="font-semibold px-5 pb-3 text-lg">
                                        {FormatVND(voucher?.voucher_id ? totalBill - voucher?.voucher_price + shipFee : totalBill + shipFee)} VND
                                    </p>

                                    <p className="px-5 pb-4 text-base text-gray-600">
                                        Chuyển đúng{" "}
                                        <b className="text-[#FF424E]">
                                            {FormatVND(
                                                voucher?.voucher_id
                                                    ? totalBill - voucher?.voucher_price + shipFee
                                                    : totalBill + shipFee
                                            )}
                                        </b>
                                        {" "}rồi tải ảnh xác nhận bên dưới.
                                    </p>
                                    <div className="px-5 pb-3">
                                        <p className="text-lg">Thêm ảnh chứng minh:</p>
                                        <div className="px-5 flex justify-center py-3">
                                            <p className="flex justify-center">
                                                <CustomUpload type="image" accept=".png, .jpg, .jpeg, .jfif" onChange={(transfer_image)=>setImgTransfer(transfer_image)} value={imgTransfer}/>
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={24} xl={10} className="text-center">
                                    <p className="font-semibold text-xl pt-5">Quét mã qua Ứng dụng ngân hàng/</p>
                                    <p className="font-semibold text-xl pb-5">Ví điện tử</p>
                                    <div className="pb-10 flex justify-center">
                                        <div>
                                            <img
                                                src={payment == 2 ? paymentSettings.bank_qr : paymentSettings.momo_qr}
                                                className="w-[300px] h-[350px]"
                                            />
                                            {payment == 2 && (
                                                <Typography.Paragraph
                                                    className="!pt-5 !mb-2 !font-semibold !text-xl"
                                                    copyable={{
                                                        text: paymentSettings.bank_name || "",
                                                        tooltips: [
                                                            "Sao chép tên ngân hàng",
                                                            "Đã sao chép"
                                                        ]
                                                    }}
                                                >
                                                    Ngân hàng: {paymentSettings.bank_name || "Chưa cập nhật"}
                                                </Typography.Paragraph>
                                            )}
                                            <p className="font-semibold pt-3 text-xl">
                                                {payment == 2
                                                    ? paymentSettings.bank_account_name
                                                    : paymentSettings.momo_account_name}
                                            </p>
                                            <div className="flex text-xl justify-center font-semibold">
                                                {payment == 2 ? "Số tài khoản:" : "Số MoMo:"}

                                                <Typography.Paragraph
                                                    className="!mb-0 !font-semibold !pl-2"
                                                    style={{fontSize: 20}}
                                                    copyable={{
                                                        text:
                                                            payment == 2
                                                                ? paymentSettings.bank_account_number
                                                                : paymentSettings.momo_account_number,
                                                        tooltips: [
                                                            payment == 2
                                                                ? "Sao chép số tài khoản"
                                                                : "Sao chép số MoMo",
                                                            "Đã sao chép"
                                                        ]
                                                    }}
                                                >
                                                    {payment == 2
                                                        ? paymentSettings.bank_account_number
                                                        : paymentSettings.momo_account_number}
                                                </Typography.Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            {payment > 0 && (
                                <Form.Item className="w-full">
                                    <button className="w-full py-2 bg-blue-500 text-white text-xl font-semibold hover:bg-blue-400" type="submit" disabled={loading}>
                                        {loading ? 'Đang đặt hàng...' : 'Đặt hàng'}
                                    </button>
                                </Form.Item>
                            )}
                        </Col>
                    )}
                </Row>
            </Form>
        </div>
    )
}